export default [
  { key: 'filename', label: 'Filename', searchable: true, sortable: true },
  { key: 'UMR', label: 'UMR', searchable: true, sortable: true },
  {
    key: 'uploaded_on',
    label: 'Upload Date',
    searchable: true,
    sortable: true,
    isDate: true,
  },
  {
    key: 'link',
    label: 'File Link',
    searchable: false,
    sortable: false,
    width: '60px',
  },
];
